import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoaderComponent } from './loader-component';
import { MatProgressSpinnerModule } from '@angular/material';
import { LoaderService } from '../loader-service';


@NgModule({
  declarations: [LoaderComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
  ],
  providers: [LoaderService],
  exports: [LoaderComponent]
})
export class LoaderModule {
}
